/* statistic */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    statistic_beginDate: null,
    statistic_lastDate: null,
    statistic_datasets: [],
    statistic_temperature_per_location: [],
    statistic_rainfall_per_location: [],
    statistic_temperature_per_location_temprange: [],
    statistic_temperature_per_location_timerange: [],
    statistic_temperature_per_location_filter: null,
    statistic_rainfall_per_location_filter: null,
    statistic_dateSelected: null,
    //v2 
    statistic_isLoading: false,
    statistic_data_temp_n_data_rainfall_x_location_destination: {},
    statistic_data_temp_x_datetimerange: {},
    table_temperature_per_location: {}
    // statistic_location_destination: [],
}

// getters
const getters = {
    statistic_location_destination: state => {
        return state.statistic_location_destination;
    },
    statistic_date: state => {
        if (state.statistic_dateSelected != null) {
            return state.statistic_dateSelected
        } else {
            if (state.statistic_beginDate != null) {
                var _start = state.statistic_beginDate.split("T");
                var _end = state.statistic_lastDate.split("T")
                return { start: _start[0], end: _end[0] }
            } else {
                return { start: state.statistic_beginDate, end: state.statistic_lastDate }
            }
        }
    },
    statistic_isLoading: state => {
        return state.statistic_isLoading;
    },
    statistic_data_date: state => {
        if (state.statistic_dateSelected != null) {
            return moment(state.statistic_dateSelected).format('YYYY-MM-DD')
        } else {
            if (state.statistic_beginDate !== null) {
                var _start = state.statistic_beginDate.split("T");
                var _end = state.statistic_lastDate.split("T")
                return _start[0] + " to " + _end[0];
            } else {
                return "N/A"
            }
        }
    },
    statistic_datasets: state => {
        return state.statistic_datasets;
    },
    statistic_temperature_per_location: state => {
        return state.statistic_temperature_per_location;
    },
    statistic_rainfall_per_location: state => {
        return state.statistic_rainfall_per_location;
    },
    statistic_temperature_per_location_timerange: state => {
        return state.statistic_temperature_per_location_timerange;
    },
    statistic_temperature_per_location_filter: state => {
        return state.statistic_temperature_per_location_filter;
    },
    statistic_rainfall_per_location_filter: state => {
        return state.statistic_rainfall_per_location_filter;
    },
    statistic_temperature_per_location_temprange: state => {
        return state.statistic_temperature_per_location_temprange;
    },
    table_temperature_per_location: state => {
        return state.table_temperature_per_location;
    }
}

// actions
const actions = {
    // start /v2 actions
    V2getstatisticDatasets(context, payload) {
        state.statistic_isLoading = true;
        state.statistic_temperature_per_location_filter = null;
        state.statistic_rainfall_per_location_filter = null;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        instance.get('v2/market/informations/statistic', request)
            .then(response => {
                const {
                    date,
                    statistic_data_temp_n_data_rainfall_x_location_destination,
                    statistic_data_temp_x_datetimerange,
                } = response.data;

                state.statistic_beginDate = date.start;
                state.statistic_lastDate = date.end;
                state.statistic_data_temp_n_data_rainfall_x_location_destination = statistic_data_temp_n_data_rainfall_x_location_destination;
                state.statistic_data_temp_x_datetimerange = statistic_data_temp_x_datetimerange;
                // state.statistic_location_destination = statistic_data_temp_x_datetimerange.location_destination;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "statistic_temperature_per_location") {
                        context.commit("V2onStatisticTemperaturePerLocation", payload);
                    } else if (stateName == "statistic_rainfall_per_location") {
                        context.commit("V2onStatisticRainFallPerLocation", payload);
                    } else if (stateName == "statistic_temperature_per_location_timerange") {
                        context.commit("V2onStatisticTemperaturePerLocationTimeRange", payload);
                    }
                })
                state.statistic_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/market/informations/statistic] syntax errors under instant.get");
            })
    },
    V2getTemperaturePerLocationFilter(context, payload) {
        if (payload.timerange !== undefined) {
            if (payload.timerange !== null) {
                var rows = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
                var rows_filtered = [];
                rows.forEach(function(item, index) {
                    if (item._id.timerange == payload.timerange) {
                        rows_filtered.push(item);
                    }
                });
                payload.rows_filtered = rows_filtered;
            } else {
                payload.rows_filtered = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
            }
            context.commit("V2onStatisticTemperaturePerLocation", payload);
        }
    },
    V2getRainFallPerLocationFilter(context, payload) {
        if (payload.timerange !== undefined) {
            if (payload.timerange !== null) {
                var rows = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
                var rows_filtered = [];
                rows.forEach(function(item, index) {
                    if (item._id.timerange == payload.timerange) {
                        rows_filtered.push(item);
                    }
                });
                payload.rows_filtered = rows_filtered;
            } else {
                payload.rows_filtered = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
            }
            context.commit("V2onStatisticRainFallPerLocation", payload);
        }
    },
    getStatisticTemperatureTimeRangeDatasets(context, payload) {
        // use for widget no. 95
        state.statistic_isLoading = true;
        state.statistic_temperature_per_location_filter = null;
        state.statistic_rainfall_per_location_filter = null;
        let _params = {};
        // calulate _params from main_filters                
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.date !== null) {
                _params.date = main_filters.date;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        instance.get('market/informations/statistic/temperature_location_time_range', request)
            .then(response => {

                const {
                    date,
                    rows,
                } = response.data;

                state.statistic_dateSelected = date
                state.statistic_data_temp_x_datetimerange = response.data;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "statistic_temperature_per_location_timerange") {
                        context.commit("onStatisticTemperaturePerLocationTimeRange", payload);
                    }
                })
                state.statistic_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/market/informations/statistic] syntax errors under instant.get");
            })
    },
    getStatisticTemperatureTempRangeDatasets(context, payload) {
        // use for widget no. 95
        state.statistic_isLoading = true;
        let _params = {};
        // calulate _params from main_filters                
        let main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.date !== null) {
                _params.date = main_filters.date;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // query data
        instance.get('market/informations/statistic/temperature_location_temp_range', request)
            .then(response => {

                const {
                    date,
                    rows,
                } = response.data;

                state.statistic_dateSelected = date
                state.statistic_data_temp_n_data_rainfall_x_location_destination = response.data;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "statistic_temperature_per_location_temprange") {
                        context.commit("onStatisticTemperaturePerLocationTempRange", payload);
                    }
                })
                state.statistic_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/market/informations/statistic] syntax errors under instant.get");
            })
    },
    getstatisticDatasets(context, payload) {
        console.log("[store/market/informations/statistic] getstatisticDatasets() DEPRECATED");
        return;
    },
    getTemperaturePerLocationFilter(context, payload) {
        console.log("[store/market/informations/statistic] getTemperaturePerLocationFilter() DEPRECATED");
        return;
    },
    getRainFallPerLocationFilter(context, payload) {
        console.log("[store/market/informations/statistic] getTemperaturePerLocationFilter() DEPRECATED");
        return;
    }
}

// mutations
const mutations = {
    // start /v2 mutations
    V2onStatisticTemperaturePerLocation(state, payload) {
        // --- start dataset for jvector map
        // items = [{label:'',data:0,location_destination:'',sum:0,avg:0]
        var rows = [];
        if (payload.timerange !== undefined) {
            rows = payload.rows_filtered
        } else {
            rows = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
        }
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {};
            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_destination);
            if (pos == -1) {
                _item['label'] = item._id.location_destination;
                _item['location_destination'] = item._id.location_destination;
                _item['data'] = 1
                _item['sum'] = item.avg_statistic_data_temp;
                _item['avg'] = item.avg_statistic_data_temp;
                items.push(_item);
            } else {
                items[pos]['data'] += 1;
                items[pos]['sum'] += item.avg_statistic_data_temp;
                items[pos]['avg'] = (items[pos]['sum'] / items[pos]['data']);
            }
        });

        if (payload.timerange !== undefined) {
            state.statistic_temperature_per_location_filter = items;
        } else {
            state.statistic_temperature_per_location = items;
        }
        // --- end dataset for jvector map 
    },
    V2onStatisticRainFallPerLocation(state, payload) {
        // --- start dataset for jvector map
        // items = [{label:'',data:0,location_destination:'',sum:0,avg:0]
        var rows = [];
        if (payload.timerange !== undefined) {
            rows = payload.rows_filtered
        } else {
            rows = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
        }
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {};
            var pos = items.map(function(e) {
                return e.location_destination;
            }).indexOf(item._id.location_destination);
            if (pos == -1) {
                _item['label'] = item._id.location_destination;
                _item['location_destination'] = item._id.location_destination;
                _item['data'] = 1
                _item['sum'] = item.avg_statistic_data_rainfall;
                _item['avg'] = item.avg_statistic_data_rainfall;
                items.push(_item);
            } else {
                items[pos]['data'] += 1;
                items[pos]['sum'] += item.avg_statistic_data_rainfall;
                items[pos]['avg'] = (items[pos]['sum'] / items[pos]['data']);
            }
        });

        if (payload.timerange !== undefined) {
            state.statistic_rainfall_per_location_filter = items;
        } else {
            state.statistic_rainfall_per_location = items;
        }
        // --- end dataset for jvector map 
    },
    onStatisticTemperaturePerLocationTimeRange(state, payload) {
        // --- start dataset for line/area chart
        let rows = state.statistic_data_temp_x_datetimerange.rows
        //var filter_datediff = state.statistic_data_temp_x_datetimerange.date.diff;
        let items = [];
        let total = 0;

        rows.forEach(function(item, index) {
            var _item = {};
            var _label = item.time_range
            var _index = parseInt(item.time_range.split("-").join(""));

            var pos = items.map(function(e) {
                return e.label;
            }).indexOf(_label);

            if (pos == -1) {
                _item['_index'] = _index;
                _item['label'] = _label;
                _item['data'] = 1;
                _item['sum'] = item.average_temp;
                _item['avg'] = item.average_temp;
                items.push(_item);
            } else {
                items[pos]['data'] += 1;
                items[pos]['sum'] += item.average_temp;
                items[pos]['avg'] = (items[pos]['sum'] / items[pos]['data']);
            }
        });

        items.sort(function(a, b) {
            return a._index - b._index;
        })

        let pos_index_time = items.findIndex((item) => item._index === 22)
        let begin_time_range = items.splice(pos_index_time, 1)
        items.unshift(...begin_time_range)

        items.forEach(function(item, index) {
            items[index].avg = numeral(item.avg).format('00');
        });
        state.statistic_temperature_per_location_timerange = items
    },
    onStatisticTemperaturePerLocationTempRange(state, payload) {
        // --- start dataset for jvector map
        // items = [{label:'',data:0,location_destination:'',sum:0,avg:0]

        //console.log(state.statistic_data_temp_n_data_rainfall_x_location_destination);

        var rows = [];
        if (payload.timerange !== undefined) {
            rows = payload.rows_filtered
        } else {
            rows = state.statistic_data_temp_n_data_rainfall_x_location_destination.rows;
        }

        let type = state.statistic_data_temp_n_data_rainfall_x_location_destination.type || null;
        let provinces = [...new Set(rows.map((item) => item.province))]
        let date_selected = state.statistic_data_temp_n_data_rainfall_x_location_destination.date || null
    
        let items = []
        let data_info = {}
        provinces.forEach((province) => {
            let province_info = rows.find((resp) => resp.province === province)
            // calculate average temperature
            let count_avg_temp = province_info.average_temps.length
            let average_temps = typeof province_info.average_temps !=='undefined' ? province_info.average_temps : [];
            let sum_of_average_temp = count_avg_temp > 1 ? parseFloat(average_temps.reduce((a, b) => a + b, 0)) / count_avg_temp : parseFloat(...average_temps)
            
            // calculate rainfall
            let count_avg_rainfall = province_info.average_rainfalls.length;
            let average_rainfalls = typeof province_info.average_rainfalls !=='undefined' ? province_info.average_rainfalls : [];
            let sum_of_rainfall = count_avg_rainfall > 1 ? parseFloat(average_rainfalls.reduce((a, b) => a + b, 0)) / count_avg_rainfall : parseFloat(...average_rainfalls)

            let weather_condition = typeof province_info.conditions !=='undefined' ? province_info.conditions.join(', ') : null
            let temp_range = typeof province_info.temp_ranges !=='undefined' ? province_info.temp_ranges : []

            data_info = {
                location_destination: province_info.province,
                avg_temp: sum_of_average_temp,
                avg_rainfall: sum_of_rainfall,
                condition: weather_condition,
                temp_ranges: temp_range
            }
            items.push(data_info)
            //console.log(`province infos `,province_info.conditions)
        })

        let table_info = {
            type: type,
            rows: items,
            date: date_selected,
            count: items.length
        }

        state.statistic_temperature_per_location_temprange = items;
        state.table_temperature_per_location = table_info
        // --- end dataset for jvector map 
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}